// extracted by mini-css-extract-plugin
export default {"zoomModal":"g3-z","image":"h3-z","button":"i3-z","isOverlayShown":"j3-z"};